export const timeOptions = [
  { id: 1, name: "Before_Noon" },
  { id: 2, name: "Afternoon" },
];
